function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}
var speed = "500";

$(document).ready(function(){


  if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
     isOnScreen($(".non-sticky-atc-button").eq(1))  ) {
    $(".sticky-atc-button").fadeOut(10);

  } else {
    $(".sticky-atc-button").fadeIn(10);
  }
  
  $(window).on('scroll',function(){
    if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
        isOnScreen($(".non-sticky-atc-button").eq(1)) ) {
      $(".sticky-atc-button").fadeOut(10);
      
    } else {
      $(".sticky-atc-button").fadeIn(10);
    }
  });	

  
$('.qty-input i').click(function() {
  val = parseInt($(this).parent().find('input').val());

  if ($(this).hasClass('less')) {
      val = val - 1;
  } else if ($(this).hasClass('more')) {
      val = val + 1;
  }

  if (val < 1) {
      val = 1;
  }

  $(this).parent().find('input').val(val);
});
});
$('.testimonial_slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots:false,
    arrows:true,
    autoplay:false,
    centerMode: true,
    centerPadding: '25%',
    prevArrow: '<button class="slick-prev slick-arrow"><span class="material-icons">arrow_back</span></button>',
    nextArrow: '<button class="slick-next slick-arrow"><span class="material-icons">arrow_forward</span></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '40%',
        }
      },
        {
          breakpoint: 991,
          settings: {
            slidesToShow:2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow:1,
            slidesToScroll: 1,
          }
        },
    ]
});
$('.landing_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots:false,
  lazyLoad: 'ondemand',
  arrows:false,
  autoplay:true,
  fade: true,
  cssEase: 'linear'
});
$('.product_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots:false,
  lazyLoad: 'ondemand',
  arrows:true,
  autoplay:false,
  prevArrow: '<button class="slick-prev slick-arrow"><span class="material-icons">arrow_back</span></button>',
  nextArrow: '<button class="slick-next slick-arrow"><span class="material-icons">arrow_forward</span></button>',
});
(function($) {

  'use strict';

  var $filters = $('.filter [data-filter]'),
    $accordion = $('.accordion [data-name]');

  $filters.on('click', function(e) {
    e.preventDefault();
    var $this = $(this);
    
    $filters.removeClass('active');
    $this.addClass('active');

    var $filterData = $this.attr('data-filter');

    if ($filterData == 'all') {
      $accordion.removeClass('is-animated')
        .fadeOut().promise().done(function() {
          $accordion.addClass('is-animated').fadeIn();
        });
    } else {
      $accordion.removeClass('is-animated')
        .fadeOut().promise().done(function() {
          $accordion.filter('[data-name = "' + $filterData + '"]')
            .addClass('is-animated').fadeIn();
        });
    }
  });

})(jQuery);

$('[data-fancybox]').fancybox({
  youtube : {
      controls : 0,
      showinfo : 0
  },
});